import { getSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGet } from '@/common/api/client/sdk.gen'
import { useQuery } from '@tanstack/react-query'

export const useSubscription = (org_id: string | undefined) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['subscription', org_id],
        queryFn: () =>
            org_id
                ? getSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGet({ path: { org_id } }).then(r => r.data!)
                : Promise.reject('No org_id'),
        enabled: !!org_id,
    })

    return {
        subscription: data,
        hasActiveSubscription: data?.status === 'active' || false,
        isLoading,
        error,
        refetch,
    }
}
